// Import Actions
import { SET_INVOICES, SET_INVOICE, REMOVE_INVOICE } from './InvoiceActions';
import { SET_IS_FETCHING } from '../App/AppActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

// Think to update reducers.js

const InvoiceReducer = (state = initialState, action) => {
    switch(action.type) {

        case SET_INVOICES:
            return {
                ...state,
                data: (action.invoiceType ? state.data.filter(invoice => invoice.type !== action.invoiceType) : []).concat(action.invoices),
                isFetching: false,
            };
        
        case SET_INVOICE:
            return {
                ...state,
                data: state.data.filter(invoice => invoice._id !== action.invoice._id).concat([action.invoice]),
                isFetching: false,
            };

        case REMOVE_INVOICE:
            return {
                ...state,
                data: state.data.filter(invoice => invoice._id !== action.invoiceId),
                isFetching: false,
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'invoices') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        default:
            return state;
    }
};

export default InvoiceReducer;
